import { render, staticRenderFns } from "./PointsManageDialog.vue?vue&type=template&id=c4a4d67e&scoped=true&"
import script from "./PointsManageDialog.vue?vue&type=script&lang=js&"
export * from "./PointsManageDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4a4d67e",
  null
  
)

export default component.exports